/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  [types.SET_SHOW_PRELOADER](state, showPreloader) {
    state.showPreloader = showPreloader;
  },
  [types.SET_PERCENT_PROGRESS](state, percentProgress) {
    state.percentProgress = percentProgress;
  }
};

export default mutations;
